/**
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/NG-ZORRO/ng-zorro-antd/blob/master/LICENSE
 */

import { Overlay } from "@angular/cdk/overlay";
import { Platform } from "@angular/cdk/platform";
import { Directive, ElementRef, EventEmitter, Input, Output, Renderer2, ViewContainerRef } from "@angular/core";

import { NzConfigService, WithConfig } from "ng-zorro-antd/core/config";

import { IndexableObject } from "ng-zorro-antd/core/types";
import { InputBoolean } from "ng-zorro-antd/core/util";
import { NzDropDownDirective } from "ng-zorro-antd/dropdown";
import { UiDropdownMenuComponent } from "./components/dropdown-menu/dropdown-menu.component";
import { UiDropdownTrigger, UiPlacementType } from "./models/dropdown.models";

@Directive({
  selector: "[ui-dropdown]",
  exportAs: "uiDropdown",
})
export class UiDropDownDirective extends NzDropDownDirective {
  @Input("uiDropdownMenu") public nzDropdownMenu: UiDropdownMenuComponent | null = null;
  @Input("uiTrigger") public nzTrigger: UiDropdownTrigger = "hover";
  @Input("uiMatchWidthElement") public nzMatchWidthElement: ElementRef | null = null;
  /**
   * @deprecated Not supported, use `nzBackdrop` instead.
   * @breaking-change 13.0.0
   */
  @Input("uiHasBackdrop") @InputBoolean() public nzHasBackdrop = false;
  @Input("uiBackdrop") @WithConfig<boolean>() @InputBoolean() public nzBackdrop = false;
  @Input("uiClickHide") @InputBoolean() public nzClickHide = true;
  @Input("uiDisabled") @InputBoolean() public nzDisabled = false;
  @Input("uiVisible") @InputBoolean() public nzVisible = false;
  @Input("uiOverlayClassName") public nzOverlayClassName = "";
  @Input("uiOverlayStyle") public nzOverlayStyle: IndexableObject = {};
  @Input("uiPlacement") public nzPlacement: UiPlacementType = "bottomLeft";
  @Output("uiVisibleChange") public readonly nzVisibleChange: EventEmitter<boolean> = new EventEmitter();

  public constructor(
    public readonly nzConfigService: NzConfigService,
    public elementRef: ElementRef,
    overlay: Overlay,
    renderer: Renderer2,
    viewContainerRef: ViewContainerRef,
    platform: Platform
  ) {
    super(nzConfigService, elementRef, overlay, renderer, viewContainerRef, platform);
  }
}
